import React, {Component} from 'react';
import {Col, Form, FormGroup, ControlLabel, FormControl, Checkbox, InputGroup, Row} from "react-bootstrap";
import {TopButtonCancel, TopButtonSave} from "../../../../../componentsTopsa/buttons/TopButtons";
import Validator from "../../../../../utilities/Validator";
import ValidatorMessages from "../../../../../shared/validatorMessages/ValidatorMessages";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import {TopAlertInformacja} from "../../../../../componentsTopsa/alerty/TopAlerts";
import TopDostepnosc from "../../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import ColorPicker from "rc-color-picker";

export default class ZnizkiForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            czyMies: false,
            nazwaDruk: '',
            nazwaZnizki: '',
            procent: 0,
            rodzaj: '',
            czyBylPrzycisk: false,
            validatorMessages: [],
            czyEsprzedaz: false,
            czyUKierowcy: false,
            czyUOperatora: false,
            ustawowa: false,
            handlowa: false,
            trasa: null,
            kolor: '#999999'
        };
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onChangeRodzaj = this.onChangeRodzaj.bind(this)
        this.onChangeNazwa = this.onChangeNazwa.bind(this)
        this.onChangeNazwaDruk = this.onChangeNazwaDruk.bind(this)
        this.onChangeProcent = this.onChangeProcent.bind(this)
        this.onChangeTrasa = this.onChangeTrasa.bind(this)
    }

    componentDidMount() {
        if (Boolean(this.props.edytowana)) {
            this.setState({
                czyMies: Boolean(this.props.edytowana.czyMies),
                nazwaDruk: this.props.edytowana.nazDruk,
                nazwaZnizki: this.props.edytowana.nazZniz,
                procent: this.props.edytowana.proc,
                rodzaj: this.props.edytowana.rodz,
                ustawowa: Boolean(this.props.edytowana.ustawowa),
                handlowa: Boolean(this.props.edytowana.handlowa),
                czyEsprzedaz: Boolean(this.props.edytowana.esprzedaz) ? true : false,
                czyUKierowcy: Boolean(this.props.edytowana.ukierowcy) ? true : false,
                czyUOperatora: Boolean(this.props.edytowana.uoperatora) ? true : false,
                trasa: Boolean(this.props.edytowana.idTr) ? this.props.trasy.find(t => t.idTr == this.props.edytowana.idTr) : null,
                kolor:this.props.edytowana.kolor,
            })

        }
    }

    componentWillReceiveProps(nextprops) {
        if (nextprops.edytowana) {
            this.setState({
                czyMies: Boolean(nextprops.edytowana.czyMies),
                nazwaDruk: nextprops.edytowana.nazDruk,
                nazwaZnizki: nextprops.edytowana.nazZniz,
                procent: nextprops.edytowana.proc,
                rodzaj: nextprops.edytowana.rodz,
                ustawowa: Boolean(nextprops.edytowana.ustawowa),
                handlowa: Boolean(nextprops.edytowana.handlowa),
                czyEsprzedaz: Boolean(nextprops.edytowana.esprzedaz) ? true : false,
                czyUKierowcy: Boolean(nextprops.edytowana.ukierowcy) ? true : false,
                czyUOperatora: Boolean(nextprops.edytowana.uoperatora) ? true : false,
                trasa: Boolean(nextprops.edytowana.idTr) ? this.props.trasy.find(t => t.idTr == nextprops.edytowana.idTr) : null,
                kolor:nextprops.edytowana.kolor,
            })
            document.getElementById('inputRodzaj').value = nextprops.edytowana.rodz;
            document.getElementById('inputNazwa').value = nextprops.edytowana.nazZniz;
            document.getElementById('inputProcent').value = nextprops.edytowana.proc;
            document.getElementById('inputNazwaDruk').value = nextprops.edytowana.nazDruk;
            document.getElementsByClassName('rc-color-picker-trigger')[0].style['background-color'] = (nextprops.edytowana.kolor.length > 1) ? nextprops.edytowana.kolor : '#999999'


        }
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    onClickZapisz() {
        this.setState({czyBylPrzycisk: true, validatorMessages: []})
        let poprawne = true;
        this.state.validatorMessages = [];

        if (this.state.rodzaj.length <= 0) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono rodzaju')
        } else if (this.state.rodzaj === 'PROM' || this.state.rodzaj === 'BASE' || this.state.rodzaj === 'BASEM') {
            poprawne = false;
            this.dodajDoValidatorMessages('Nazwa zniżki nie może być PROM, BASE bądź BASEM - te zniżki już istnieją!')
        }
        if (this.state.nazwaZnizki.length <= 0) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono nazwy zniżki')
        }
        if (this.state.nazwaDruk.length <= 0) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono nazwy druku')
        }
        if (this.state.procent.length <= 0) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono procentu')
        }
        if (!this.state.handlowa && !this.state.ustawowa) {
            poprawne = false;
            this.dodajDoValidatorMessages('Musi zostać wybrany co najmniej jeden rodzaj zniżki handlowa / ustawowa!')
        }
        if (!Validator.validateInt(this.state.procent)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Procent musi być liczbą całkowitą')
        }

        if (this.state.procent < 0 || this.state.procent > 100) {
            poprawne = false;
            this.dodajDoValidatorMessages('Procent musi być w zakresie 0 - 100')
        }

        if (poprawne) {
            this.state.validatorMessages = [];
            this.setState({czyBylPrzycisk: false, validatorMessages: []})

            let msc = 0;
            if (this.state.czyMies) msc = 1;

            let data = {
                "czyMies": msc,
                "nazDruk": this.state.nazwaDruk.trim(),
                "nazZniz": this.state.nazwaZnizki,
                "proc": parseInt(this.state.procent),
                "rodz": this.state.rodzaj,
                "esprzedaz": this.state.czyEsprzedaz,
                "ukierowcy": this.state.czyUKierowcy,
                "uoperatora": this.state.czyUOperatora,
                "ustawowa": this.state.ustawowa,
                "handlowa": this.state.handlowa,
                "idTr": Boolean(this.state.trasa) ? this.state.trasa.idTr : 0,
                kolor: this.state.kolor
            }
            this.props.handleZapisz(data, this.props.edytowana)
        }
    }

    onChangeRodzaj(e) {
        if (e.target.value.length <= 5) {
            this.setState({rodzaj: e.target.value})
        }
        else {
            document.getElementById('inputRodzaj').value = this.state.rodzaj
            this.setState({rodzaj: this.state.rodzaj})
        }

    }

    onChangeNazwa(e) {
        if (Validator.validateLenghtWithClearing(e.target.value, 120, 'inputNazwa', this.state.nazwaZnizki))
            this.setState({nazwaZnizki: e.target.value})
    }

    onChangeNazwaDruk(e) {
        if (Validator.validateLenghtWithClearing(e.target.value, 30, 'inputNazwaDruk', this.state.nazwaDruk)) {
            this.setState({nazwaDruk: e.target.value})
        }

    }

    onChangeProcent(e) {
        this.setState({procent: e.target.value})
    }

    onChangeTrasa(e) {
        this.setState({trasa: e})
    }

    formatTrasaSelect(option) {
        return <div><span className={'label label-ebus-primary'}>{option.kodTrasy}</span> {option.nazTr} <TopDostepnosc wartoscWarunek={0}
                                                                                                                        wartosc={option.status}
                                                                                                                        czyMarginesLewy={true}/></div>
    }

    render() {

        return (
            <div>
                <fieldset>
                    <div className={'fieldset-label'}>{Boolean(this.props.edytowana) ? 'Edycja zniżki' : 'Nowa zniżka'}</div>
                    <Form horizontal={true}>
                        <FormGroup>
                            <Col xs={12} md={6} lg={2}>
                                <ControlLabel>
                                    Rodzaj (kod) <span className={'req'}>*</span> <span
                                    style={{fontSize: '12px', color: 'grey', fontStyle: 'italic', fontWeight: 'normal'}}>{this.state.rodzaj.length}/5 znaków</span>
                                </ControlLabel>
                                <FormControl onChange={this.onChangeRodzaj} id={'inputRodzaj'}
                                             defaultValue={Boolean(this.props.edytowana) ? this.props.edytowana.rodz : ''}/>
                            </Col>
                            <Col xs={12} md={6} lg={4}>
                                <ControlLabel>
                                    Nazwa zniżki <span className={'req'}>*</span> <span style={{
                                    fontSize: '12px',
                                    color: 'grey',
                                    fontStyle: 'italic',
                                    fontWeight: 'normal'
                                }}>{this.state.nazwaZnizki.length}/120 znaków</span>
                                </ControlLabel>
                                <FormControl onChange={this.onChangeNazwa} id={'inputNazwa'}
                                             defaultValue={Boolean(this.props.edytowana) ? this.props.edytowana.nazZniz : ''}/>
                            </Col>
                            <Col xs={12} md={6} lg={5}>
                                <div className={'add-label-margin'}></div>
                                <Checkbox onClick={() => this.setState({czyMies: !this.state.czyMies})} checked={this.state.czyMies} inline={true}>
                                    Czy miesięczny?
                                </Checkbox>
                                <Checkbox onClick={() => this.setState({ustawowa: !this.state.ustawowa})} checked={this.state.ustawowa} inline={true}>
                                    Czy ustawowa?
                                </Checkbox>
                                <Checkbox onClick={() => this.setState({handlowa: !this.state.handlowa})} checked={this.state.handlowa} inline={true}>
                                    Czy handlowa?
                                </Checkbox>
                                <br />
                                <Checkbox onClick={() => this.setState({czyUOperatora: !this.state.czyUOperatora})} checked={this.state.czyUOperatora}
                                          inline={true}>
                                    Czy u operatora?
                                </Checkbox>
                                <Checkbox onClick={() => this.setState({czyEsprzedaz: !this.state.czyEsprzedaz})} checked={this.state.czyEsprzedaz}
                                          inline={true}>
                                    Czy esprzedaż?
                                </Checkbox>
                                <Checkbox onClick={() => this.setState({czyUKierowcy: !this.state.czyUKierowcy})} checked={this.state.czyUKierowcy}
                                          inline={true}>
                                    Czy u kierowcy?
                                </Checkbox>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12} md={6} lg={2}>
                                <ControlLabel>
                                    Kolor zniżki
                                </ControlLabel>
                                <div>
                                    <ColorPicker defaultColor={Boolean(this.props.edytowana) ? this.props.edytowana.kolor : '#999999'}
                                                 onClose={(e)=>{this.setState({kolor: e.color})}} id={'inputKolor'}/><span
                                    style={{marginLeft: '10px', color: 'grey', fontSize: '12px', fontStyle: 'italic', verticalAlign: '5px'}}>(kliknij aby wybrać)</span>
                                </div>
                            </Col>
                            <Col xs={12} md={6} lg={4}>
                                <Row>
                                    <Col lg={4}>
                                        <ControlLabel>
                                            Procent <span className={'req'}>*</span>
                                        </ControlLabel>
                                        <InputGroup>
                                            <FormControl type={'number'} onChange={this.onChangeProcent} id={'inputProcent'}
                                                         defaultValue={Boolean(this.props.edytowana) ? this.props.edytowana.proc : 0}/>
                                            <InputGroup.Addon>%</InputGroup.Addon>
                                        </InputGroup>
                                    </Col>
                                    <Col lg={8}>
                                        <ControlLabel>
                                            Nazwa na druku <span className={'req'}>*</span> <span style={{
                                            fontSize: '12px',
                                            color: 'grey',
                                            fontStyle: 'italic',
                                            fontWeight: 'normal'
                                        }}>{this.state.nazwaDruk.length}/30 znaków</span>
                                        </ControlLabel>
                                        <FormControl onChange={this.onChangeNazwaDruk} id={'inputNazwaDruk'}
                                                     defaultValue={Boolean(this.props.edytowana) ? this.props.edytowana.nazDruk : ''}/>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} md={6} lg={3}>
                                <ControlLabel>Na trasę:</ControlLabel>
                                <TopSelect onChange={this.onChangeTrasa}
                                           value={this.state.trasa}
                                           options={this.props.trasy}
                                           valueKey={'idTr'}
                                           labelKey={'nazTr'}
                                           valueRenderer={this.formatTrasaSelect}
                                           optionRenderer={this.formatTrasaSelect}
                                           placeholder={'Wybierz trasę...'}
                                />
                                <TopAlertInformacja text={'Jeśli pole pozostanie puste, zniżka jest dla wszystkich tras'}/>
                            </Col>
                            <Col xs={12} md={6} lg={3}>
                                <div className={'add-label-margin'}></div>
                                <TopButtonCancel onClick={() => {
                                    this.props.handleAnuluj()
                                }} text={'Anuluj'}/>
                                <TopButtonSave onClick={this.onClickZapisz} text={'Zapisz'}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <ValidatorMessages messages={this.state.validatorMessages}/>
                        </FormGroup>
                    </Form>
                </fieldset>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/znizki/components/ZnizkiForm.js